// Phase 19 · Community V2 · Polling hook for notifications
import { useEffect, useState, useRef } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function useCommunityPolling(intervalMs = 30000, enabled = true) {
    const [state, setState] = useState({
        items: [],
        unread_count: 0,
        last_polled_at: null,
    });
    const lastSinceRef = useRef(null);

    useEffect(() => {
        if (!enabled) return undefined;
        let stopped = false;

        const poll = async () => {
            if (typeof document !== "undefined" && document.hidden) return;
            try {
                const url = new URL(API + "/api/community/notifications/poll");
                url.searchParams.set("limit", "20");
                if (lastSinceRef.current) url.searchParams.set("since", lastSinceRef.current);
                const r = await fetch(url.toString(), { credentials: "include" });
                if (r.status === 401 || r.status === 403 || r.status === 503) return;
                if (!r.ok) return;
                const d = await r.json();
                if (stopped) return;
                setState((prev) => ({
                    items: (d.items || []).length ? d.items : prev.items,
                    unread_count: d.unread_count ?? prev.unread_count,
                    last_polled_at: d.last_polled_at,
                }));
                if ((d.items || []).length && d.items[0]?.created_at) {
                    lastSinceRef.current = d.items[0].created_at;
                }
            } catch (e) { /* silent */ }
        };

        poll();
        const id = setInterval(poll, intervalMs);
        const onVis = () => { if (!document.hidden) poll(); };
        document.addEventListener("visibilitychange", onVis);
        return () => {
            stopped = true;
            clearInterval(id);
            document.removeEventListener("visibilitychange", onVis);
        };
    }, [intervalMs, enabled]);

    const markRead = async (ids) => {
        try {
            await fetch(API + "/api/community/notifications/mark-read", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({ notification_ids: ids || [] }),
            });
            setState((prev) => ({
                ...prev,
                items: prev.items.map((i) => ids.includes(i.id) ? { ...i, read: true } : i),
                unread_count: Math.max(0, prev.unread_count - (ids || []).length),
            }));
        } catch {}
    };

    const markAllRead = async () => {
        try {
            await fetch(API + "/api/community/notifications/mark-all-read", {
                method: "POST",
                credentials: "include",
            });
            setState((prev) => ({
                ...prev,
                items: prev.items.map((i) => ({ ...i, read: true })),
                unread_count: 0,
            }));
        } catch {}
    };

    return { ...state, markRead, markAllRead };
}
